import React from "react";
import {
  client1, client2, client3, client4, client5, client6, client7,
  client8, client9, client10, client11, client12, client13, client14,
} from "../../Assets.tsx";

/* Theme  : same as Our Products page.
            navy #064081 | blue #0a66c2 | tint #e6eef8 | page bg #f5f8fc
   Layout : heading + 2 marquee rows moving in opposite directions.
   Logos  : always on a light tile in ORIGINAL colours (no filters). */

type Company = { logo: string; name: string; url: string };

const CompanyLogos: Company[] = [
  { logo: client1, name: "Universal Bio Con", url: "https://universalbiocon.com" },
  { logo: client2, name: "GS Enterprises", url: "https://gsenterprisessolutions.com/" },
  { logo: client3, name: "Kalpataru Interiors", url: "https://thekalpataruinteriors.com/" },
  { logo: client4, name: "Harshnil Powercon", url: "https://harshnilpowercon.com" },
  { logo: client12, name: "Deshmukh & Associates", url: "https://deshmukhassociates-4241.web.app/" },
  { logo: client5, name: "Infinite Auto Herb", url: "https://infiniteautoherb.com" },
  { logo: client6, name: "Neon Solutions", url: "https://neonsolutionspune.com/" },
  { logo: client7, name: "Eagel Villa", url: "https://eaglevilla.in/" },
  { logo: client8, name: "Green Gold Industries", url: "https://greengoldindustries.com" },
  { logo: client9, name: "HRBridge", url: "https://hrbridgeau.com/" },
  { logo: client10, name: "Ladakh International", url: "https://ladakhinternational.com/" },
  { logo: client11, name: "DigiBridge Global", url: "https://digibridgeglobal.com/" },
  { logo: client13, name: "Unitree Finance", url: "https://www.unitreefinance.com.au/" },
  { logo: client14, name: "DigiUnix", url: "https://digiunix.ai/" },
];

const half = Math.ceil(CompanyLogos.length / 2);
const ROW_ONE = CompanyLogos.slice(0, half);
const ROW_TWO = CompanyLogos.slice(half);

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Ubuntu:wght@700&display=swap");

.cs{--text:#4e5356;--head:#4573a6;--btn:#2596be;--tint:#eef6fa;--line:#d3e4ed;
  position:relative;overflow:hidden;padding:80px 0 90px;text-align:center;
  font-family:"Open Sans",sans-serif;font-weight:400;color:var(--text);
  background:linear-gradient(180deg,#eef6fa 0%,#fff 55%,#eef6fa 100%)}
.cs::before{content:"";position:absolute;inset:0;pointer-events:none;
  background-image:radial-gradient(rgba(69,115,166,.12) 1.2px,transparent 1.2px);background-size:26px 26px;
  -webkit-mask-image:linear-gradient(180deg,#000,transparent 70%);mask-image:linear-gradient(180deg,#000,transparent 70%)}
.cs>*{position:relative}

/* header: same as OurProducts */
.cs-chip{display:inline-block;margin-bottom:16px;padding:6px 18px;border-radius:50px;background:#fff;border:1px solid var(--line);
  color:var(--head);font-family:"Open Sans",sans-serif;font-weight:400;font-size:12px;letter-spacing:2px;text-transform:uppercase}
.cs h2{margin:0 0 14px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:42px;line-height:1.15;color:var(--head);
  cursor:default;transition:color .35s,letter-spacing .35s}
.cs h2:hover{color:var(--btn);letter-spacing:.6px}
.cs-sub{display:flex;align-items:center;justify-content:center;gap:12px;margin:0 0 50px}
.cs-sub i{display:block;height:2px;width:40px;border-radius:2px;background:var(--btn)}.cs-sub i:last-child{background:var(--head)}
.cs-sub p{margin:0;font-family:"Open Sans",sans-serif;font-weight:400;font-size:15px;color:var(--text)}

/* rows */
.cs-row{overflow:hidden;padding:14px 0;
  -webkit-mask-image:linear-gradient(90deg,transparent,#000 10%,#000 90%,transparent);
  mask-image:linear-gradient(90deg,transparent,#000 10%,#000 90%,transparent)}
.cs-track{display:flex;width:max-content;animation:csScroll 38s linear infinite}
.cs-row.rev .cs-track{animation-direction:reverse;animation-duration:44s}
.cs-row:hover .cs-track{animation-play-state:paused}
@keyframes csScroll{to{transform:translateX(-50%)}}

/* ---------- CARD ---------- */
.cs-card{position:relative;overflow:hidden;flex:none;width:230px;margin-right:22px;padding:26px 18px 22px;border-radius:24px;
  display:flex;flex-direction:column;align-items:center;gap:14px;text-decoration:none;
  background:#fff;border:1px solid var(--line);box-shadow:0 18px 36px -26px rgba(69,115,166,.55);
  transition:transform .4s cubic-bezier(.3,1.4,.5,1),box-shadow .4s,border-color .4s,opacity .35s}
.cs-card:hover{transform:translateY(-10px);border-color:rgba(37,150,190,.5);
  box-shadow:0 30px 50px -22px rgba(37,150,190,.7),0 0 0 4px rgba(37,150,190,.07)}
.cs-row:hover .cs-card:not(:hover){opacity:.55}

.cs-top{position:absolute;top:0;left:0;width:100%;height:5px;transform:scaleX(0);transform-origin:left;
  background:linear-gradient(90deg,var(--head),var(--btn));transition:transform .55s cubic-bezier(.2,.8,.2,1)}
.cs-card:hover .cs-top{transform:scaleX(1)}

.cs-arrow{position:absolute;top:14px;right:14px;width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;
  background:linear-gradient(135deg,var(--head),var(--btn));color:#fff;font-size:14px;opacity:0;transform:translate(-8px,8px) scale(.6);
  transition:opacity .35s,transform .45s cubic-bezier(.3,1.6,.5,1)}
.cs-card:hover .cs-arrow{opacity:1;transform:none}

/* logo tile: light bg, logo keeps its colours */
.cs-tile{width:112px;height:112px;border-radius:28px;background:var(--tint);display:flex;align-items:center;justify-content:center;
  transition:background .4s,box-shadow .4s,transform .5s cubic-bezier(.3,1.4,.5,1)}
.cs-tile img{width:72px;height:72px;object-fit:contain;transition:transform .5s cubic-bezier(.3,1.4,.5,1)}
.cs-card:hover .cs-tile{background:#fff;box-shadow:0 10px 22px -8px rgba(0,0,0,.35)}
.cs-card:hover .cs-tile img{transform:scale(1.1)}

/* name = same as OurProducts card h3 (Ubuntu Bold 20px, --head) */
.cs-name{position:relative;margin:0;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:20px;letter-spacing:.6px;line-height:1.35;
  color:var(--head);white-space:normal;text-align:center;min-height:54px;display:flex;align-items:center;justify-content:center}
.cs-name::after{content:"";position:absolute;left:50%;bottom:-4px;height:2px;width:0;background:var(--btn);transform:translateX(-50%);
  transition:width .45s cubic-bezier(.2,.8,.2,1)}
.cs-card:hover .cs-name::after{width:60%}

/* ---------- RESPONSIVE ---------- */
@media(max-width:600px){
  .cs{padding:64px 0 70px}.cs h2{font-size:30px}.cs-sub{margin-bottom:34px}
  .cs-card{width:178px;margin-right:16px;padding:22px 14px 18px}
  .cs-tile{width:88px;height:88px;border-radius:22px}.cs-tile img{width:56px;height:56px}
  .cs-name{font-size:16px;min-height:44px}
  .cs-row{-webkit-mask-image:none;mask-image:none}
}
@media(prefers-reduced-motion:reduce){
  .cs *,.cs *::before,.cs *::after{animation:none!important;transition:none!important}
  .cs-row{overflow-x:auto}
}
`;

const Row = ({ items, reverse }: { items: Company[]; reverse?: boolean }) => (
  <div className={"cs-row" + (reverse ? " rev" : "")}>
    <div className="cs-track">
      {/* list repeated twice so the loop is seamless */}
      {[...items, ...items].map((item, i) => (
        <a
          key={i}
          className="cs-card"
          href={item.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.name}
        >
          <div className="cs-top" />
          <span className="cs-arrow">↗</span>
          <div className="cs-tile">
            <img src={item.logo} alt={item.name} loading="lazy" />
          </div>
          <p className="cs-name">{item.name}</p>
        </a>
      ))}
    </div>
  </div>
);

const CompanySlider = () => {
  return (
    <div className="cs">
      <style>{STYLES}</style>

      <div className="cs-chip">Trusted By</div>
      <h2>Our Reputed Clients</h2>
      <div className="cs-sub">
        <i />
        <p>Businesses that trust us to build their products.</p>
        <i />
      </div>

      <Row items={ROW_ONE} />
      <Row items={ROW_TWO} reverse />
    </div>
  );
};

export default CompanySlider;